import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _appliedDiscount = {
    discountAmount: 'DOUBLE',
    afterDiscountAmount: 'DOUBLE',
};
var _bulkCreateCouponResult = { coupon: '_coupon' };
var _bulkCreateCouponsRequest = { specifications: '_specification' };
var _bulkCreateCouponsResponse = { results: '_bulkCreateCouponResult' };
var _bulkDeleteCouponsRequest = {};
var _bulkDeleteCouponsResponse = {};
var _calculateRequest = { discount: '_specification', cart: '_cart' };
var _calculateResponse = { cart: '_cart' };
var _cart = {
    lineItems: '_lineItem',
    shipping: '_shipping',
    totals: '_totals',
};
var _coupon = { specification: '_specification' };
var _createCouponRequest = { specification: '_specification' };
var _createCouponResponse = {};
var _deleteCouponRequest = {};
var _deleteCouponResponse = {};
var _getCouponRequest = {};
var _getCouponResponse = { coupon: '_coupon' };
var _hasCouponsRequest = {};
var _hasCouponsResponse = {};
var _increaseUsageRequest = {};
var _increaseUsageResponse = {};
var _lineItem = { amount: 'DOUBLE', appliedDiscount: '_appliedDiscount' };
var _queryCouponsRequest = {};
var _queryCouponsResponse = { coupons: '_coupon' };
var _shipping = { amount: 'DOUBLE', appliedDiscount: '_appliedDiscount' };
var _specification = {
    minimumSubtotal: 'google.protobuf.DoubleValue',
    moneyOffAmount: 'DOUBLE',
    percentOffRate: 'DOUBLE',
    fixedPriceAmount: 'DOUBLE',
};
var _totals = { subTotal: 'DOUBLE', discount: 'DOUBLE', total: 'DOUBLE' };
var _updateCouponRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    specification: '_specification',
};
var _updateCouponResponse = {};
function resolveWixCouponsApiV2CouponsV2Url(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/coupons-server',
                destPath: '',
            },
            {
                srcPath: '/_api/coupons-server',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/coupons-server',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/stores/v2/coupons',
                destPath: '/v2/coupons',
            },
            {
                srcPath: '/stores/v2/bulk/coupons',
                destPath: '/v2/bulk/coupons',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/coupons-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/coupons-server',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/coupons-server',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/coupons-server',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/coupons-server',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/coupons-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a new coupon.
 *
 * When creating a coupon, the `specification` object must contain values for `name`, `code`, `startTime`,
 * and either `scope` or `minimumSubtotal`. The exception is for a `freeShipping` coupon type, for which you cannot apply
 * a `scope` and `minimumSubtotal` is optional.
 *
 * The coupon `scope` defines the items a coupon applies to. A coupon can apply to all items in a specific Wix application,
 * a group within the application, or a single item within a group.
 * See [valid scope values](https://dev.wix.com/api/rest/coupons/coupons/valid-scope-values).
 *
 * The `specification` object must also contain a value for exactly 1 of the following coupon properties.
 * This defines the coupon type.
 *
 * + `"moneyOffAmount"`
 * + `"percentOffRate"`
 * + `"freeShipping"`
 * + `"fixedPriceAmount"`
 * + `"buyXGetY"`
 */
export function create(payload) {
    var _a = serializer(_createCouponRequest, { _specification: _specification }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCouponResponse, {}).fromJSON;
    function __create(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecommerce.coupons.v2.coupon',
            method: 'POST',
            methodFqn: 'wix.coupons.api.v2.CouponsV2.Create',
            url: resolveWixCouponsApiV2CouponsV2Url({
                protoPath: '/v2/coupons',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __create.fromReq = fromReq;
    __create.__isAmbassador = true;
    return __create;
}
/**
 * Updates a coupon.
 *
 * Only the properties passed in the `specification` object will be updated. All other properties will remain the same.
 *
 * To remove a value from the coupon, pass its corresponding property with a value of `null`.
 *
 * When updating a coupon, you cannot change the coupon's `type`. For example, if the coupon's `type` is `moneyOffAmount`,
 * you cannot change it to `fixedPriceAmount`. You can update the coupon type's value. For example, you can change the
 * value of `moneyOffAmount` from `5` to `10`.
 *
 * The coupon `scope` defines the items a coupon applies to. A coupon can apply to all items in a specific Wix application,
 * a group within the application, or a single item within a group.
 * See [valid scope values](https://dev.wix.com/api/rest/coupons/coupons/valid-scope-values).
 */
export function update(payload) {
    var _a = serializer(_updateCouponRequest, { _specification: _specification }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCouponResponse, {}).fromJSON;
    function __update(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecommerce.coupons.v2.coupon',
            method: 'PATCH',
            methodFqn: 'wix.coupons.api.v2.CouponsV2.Update',
            url: resolveWixCouponsApiV2CouponsV2Url({
                protoPath: '/v2/coupons/{id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __update.fromReq = fromReq;
    __update.__isAmbassador = true;
    return __update;
}
/** Retrieves a coupon by ID. */
export function get(payload) {
    var _a = serializer(_getCouponRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCouponResponse, {
        _coupon: _coupon,
        _specification: _specification,
    }).fromJSON;
    function __get(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecommerce.coupons.v2.coupon',
            method: 'GET',
            methodFqn: 'wix.coupons.api.v2.CouponsV2.Get',
            url: resolveWixCouponsApiV2CouponsV2Url({
                protoPath: '/v2/coupons/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveWixCouponsApiV2CouponsV2Url({
                        protoPath: '/v2/coupons/{id}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __get.fromReq = fromReq;
    __get.__isAmbassador = true;
    return __get;
}
/** Deletes a coupon. */
export function _delete(payload) {
    var _a = serializer(_deleteCouponRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteCouponResponse, {}).fromJSON;
    function ___delete(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecommerce.coupons.v2.coupon',
            method: 'DELETE',
            methodFqn: 'wix.coupons.api.v2.CouponsV2._Delete',
            url: resolveWixCouponsApiV2CouponsV2Url({
                protoPath: '/v2/coupons/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    ___delete.fromReq = fromReq;
    ___delete.__isAmbassador = true;
    return ___delete;
}
/**
 * Retrieves a list of coupons with pagination and filters.
 * A maximum of 100 coupons will be returned per request.
 */
export function query(payload) {
    var _a = serializer(_queryCouponsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryCouponsResponse, {
        _coupon: _coupon,
        _specification: _specification,
    }).fromJSON;
    function __query(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecommerce.coupons.v2.coupon',
            method: 'POST',
            methodFqn: 'wix.coupons.api.v2.CouponsV2.Query',
            url: resolveWixCouponsApiV2CouponsV2Url({
                protoPath: '/v2/coupons/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __query.fromReq = fromReq;
    __query.__isAmbassador = true;
    return __query;
}
/**
 * Calculate a cart's total price after applying a coupon.
 * Pass the Cart with line items and shipping, and the cart will be returned
 * along with its coupon's calculations applied.
 */
export function calculateCart(payload) {
    var _a = serializer(_calculateRequest, {
        _appliedDiscount: _appliedDiscount,
        _cart: _cart,
        _lineItem: _lineItem,
        _shipping: _shipping,
        _specification: _specification,
        _totals: _totals,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_calculateResponse, {
        _appliedDiscount: _appliedDiscount,
        _cart: _cart,
        _lineItem: _lineItem,
        _shipping: _shipping,
        _totals: _totals,
    }).fromJSON;
    function __calculateCart(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecommerce.coupons.v2.coupon',
            method: 'POST',
            methodFqn: 'wix.coupons.api.v2.CouponsV2.CalculateCart',
            url: resolveWixCouponsApiV2CouponsV2Url({
                protoPath: '/api/v2/coupons/codes/{code}/calculate-cart',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __calculateCart.fromReq = fromReq;
    __calculateCart.__isAmbassador = true;
    return __calculateCart;
}
/**
 * It is the responsibility of the payment process to call this endpoint after
 * the coupon was used.
 */
export function increaseUsage(payload) {
    var _a = serializer(_increaseUsageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_increaseUsageResponse, {}).fromJSON;
    function __increaseUsage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecommerce.coupons.v2.coupon',
            method: 'POST',
            methodFqn: 'wix.coupons.api.v2.CouponsV2.IncreaseUsage',
            url: resolveWixCouponsApiV2CouponsV2Url({
                protoPath: '/api/v2/coupons/{id}/increase-usage',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __increaseUsage.fromReq = fromReq;
    __increaseUsage.__isAmbassador = true;
    return __increaseUsage;
}
/** Returns true if the site has ever had any coupons (even if they have all been deleted or deactivated). */
export function hasCoupons(payload) {
    var _a = serializer(_hasCouponsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_hasCouponsResponse, {}).fromJSON;
    function __hasCoupons(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecommerce.coupons.v2.coupon',
            method: 'GET',
            methodFqn: 'wix.coupons.api.v2.CouponsV2.HasCoupons',
            url: resolveWixCouponsApiV2CouponsV2Url({
                protoPath: '/api/v2/coupons/has-coupons',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __hasCoupons.fromReq = fromReq;
    __hasCoupons.__isAmbassador = true;
    return __hasCoupons;
}
/** Deletes multiple coupons. */
export function bulkDeleteCoupons(payload) {
    var _a = serializer(_bulkDeleteCouponsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteCouponsResponse, {}).fromJSON;
    function __bulkDeleteCoupons(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecommerce.coupons.v2.coupon',
            method: 'POST',
            methodFqn: 'wix.coupons.api.v2.CouponsV2.BulkDeleteCoupons',
            url: resolveWixCouponsApiV2CouponsV2Url({
                protoPath: '/v2/bulk/coupons/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteCoupons.fromReq = fromReq;
    __bulkDeleteCoupons.__isAmbassador = true;
    return __bulkDeleteCoupons;
}
/** Creates multiple coupons. */
export function bulkCreateCoupons(payload) {
    var _a = serializer(_bulkCreateCouponsRequest, { _specification: _specification }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateCouponsResponse, {
        _bulkCreateCouponResult: _bulkCreateCouponResult,
        _coupon: _coupon,
        _specification: _specification,
    }).fromJSON;
    function __bulkCreateCoupons(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecommerce.coupons.v2.coupon',
            method: 'POST',
            methodFqn: 'wix.coupons.api.v2.CouponsV2.BulkCreateCoupons',
            url: resolveWixCouponsApiV2CouponsV2Url({
                protoPath: '/v2/bulk/coupons/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateCoupons.fromReq = fromReq;
    __bulkCreateCoupons.__isAmbassador = true;
    return __bulkCreateCoupons;
}
//# sourceMappingURL=http.impl.js.map